//icons
import {
  IconLayoutDashboard,
  IconFileText,
  IconBriefcase,
  IconListCheck,
  IconUserQuestion,
  IconSettings,
  IconHelp,
  IconShieldCheck,
} from "@tabler/icons-react";

// components

const sidebar = {
  nav_links: [
    {
      label: "Dashboard",
      key: "1",
      icon: IconLayoutDashboard,
      link: "/dashboard",
    },
    {
      label: "Document",
      key: "2",
      icon: IconFileText,
      link: "/dashboard/documents",
    },
    {
      label: "Opportunity",
      key: "3",
      icon: IconBriefcase,
      link: "/dashboard/opportunity",
    },
    {
      label: "Services",
      key: "4",
      icon: IconListCheck,
      link: "/dashboard/services",
    },
    {
      label: "Requests",
      key: "5",
      icon: IconUserQuestion,
      link: "/dashboard/requests",
    },
    {
      label: "Compliance",
      key: "6",
      icon: IconShieldCheck,
      link: "/dashboard/compliance",
    },
    // {
    //   label: "Notification",
    //   key: "6",
    //   icon: notification,
    //   link: "/dashboard/notifications",
    // },
  ],
  settings: [
    {
      label: "Settings",
      key: "7",
      icon: IconSettings,
      link: "/dashboard/settings",
    },
    {
      label: "Help Center",
      key: "8",
      icon: IconHelp,
      link: "/help-center",
    },
  ],
};
export default sidebar;
